import { HEADLINER_USER_SERVICE_URL } from 'config';

export const HEADLINER_USER_SERVICE_V1_URL = `${HEADLINER_USER_SERVICE_URL}/api/v1/headliner-user`;
export const HEADLINER_USER_SERVICE_V1_USER_PREF_URL = `${HEADLINER_USER_SERVICE_V1_URL}/user-pref`;
export const HEADLINER_USER_SERVICE_V1_EDDY_PROJECT_LANGUAGE_URL = `${HEADLINER_USER_SERVICE_V1_URL}/language/eddy-project`;

export const HEADLINER_USER_SERVICE_V2_URL = `${HEADLINER_USER_SERVICE_URL}/api/v2/headliner-user`;
export const HEADLINER_USER_SERVICE_V2_DISPLAY_PREF_URL = `${HEADLINER_USER_SERVICE_V2_URL}/display-pref`;
